// extracted by mini-css-extract-plugin
module.exports = {"mainCont":"style_mainCont__3VWsp","headPart":"style_headPart__19zPZ","closeBtn":"style_closeBtn__AG1TI","link":"style_link__2Canj"};